import { Pipe, PipeTransform } from '@angular/core';

import { visibilidades } from './atividade-filter-visibilidade';

@Pipe({
    name: 'atividadeFilterVisibilidade'
})
export class AtividadeFilterVisibilidadePipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = visibilidades.findIndex(visibilidade => visibilidade.id === value);
        if (index > -1) {
            return visibilidades[index].nome;
        }
        return '';
    }
}
